import { useParams } from "react-router";
import {
  useGetInspectionQuery,
  useInspectionUpdateCompanyMutation,
} from "@/services/backend/inspections/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  fieldErrorsForPrefix,
  useErrArtefactNotReady,
} from "@/shared/service-manager/artefact/err-artefact-not-ready";
import { CompanyCardWithMutation } from "@/shared/components/domain/company/company-card";

export function CompanyIndexRoute() {
  const { reportId } = useParams();
  const { notReadyError, resetNotReadyErrorField } = useErrArtefactNotReady();
  const { data, isLoading, error } = useGetInspectionQuery({
    id: reportId as string,
  });

  if (isLoading || !data) {
    return <div />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <CompanyCardWithMutation
      id={reportId as string}
      company={data.inspection.company}
      companyAddress={data.inspection.companyAddress}
      mutation={useInspectionUpdateCompanyMutation}
      fieldErrors={fieldErrorsForPrefix(notReadyError, "company.")}
      resetFieldError={(field) => resetNotReadyErrorField(`company.${field}`)}
      disabled={!!data.inspection.immutable}
    />
  );
}
